import { render, staticRenderFns } from "./index.vue?vue&type=template&id=0abb8792&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0abb8792",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\zjj\\view-pc\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0abb8792')) {
      api.createRecord('0abb8792', component.options)
    } else {
      api.reload('0abb8792', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=0abb8792&scoped=true", function () {
      api.rerender('0abb8792', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/customer/setup/dictionary/index.vue"
export default component.exports